<template>
  <el-dialog
    v-model="visible"
    :title="dialogConfig.type ? '新建' : '编辑'"
    width="60%"
    :close-on-click-modal="false"
  >
    <el-form
      :model="formData"
      :rules="rules"
      ref="ruleRef"
      label-width="120"
      v-loading="loading"
    >
      <el-row :gutter="10">
        <el-col :span="8"
          ><el-form-item label="药剂名称：" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入名称"
              :maxlength="20"
            /> </el-form-item
        ></el-col>
        <el-col :span="8"
          ><el-form-item label="药剂编号：" prop="number">
            <el-input
              v-model="formData.number"
              placeholder="请输入编号"
              :maxlength="40"
            /> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="药剂类别：" prop="categoryId">
            <el-tree-select
              v-model="formData.categoryId"
              :data="dialogConfig.tree"
              :render-after-expand="false"
              show-checkbox
              :props="defaultProps"
              :check-strictly="true"
              node-key="id"
              style="width: 100%"
            /> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8"
          ><el-form-item label="药剂简称：" prop="nickname">
            <el-input
              v-model="formData.nickname"
              placeholder="请输入药剂简称"
              :maxlength="20"
            /> </el-form-item
        ></el-col>
        <el-col :span="8"
          ><el-form-item label="药剂单价：" prop="price">
            <el-input
              v-model="formData.price"
              placeholder="请输入药剂单价"
              :maxlength="20"
            >
              <template #append>元</template>
            </el-input>
          </el-form-item></el-col
        >
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSUbmit()"
          :disabled="buttonLoading"
        >
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import {
  queryMedicamentById,
  insertMedicament,
  updateMedicament,
} from "@/api/medicament";
import { ElMessage } from "element-plus";

// 事件传递
const emits = defineEmits(["afterSave"]);

// 弹窗控制
const visible = ref(false);

// 遮罩
const loading = ref(false);

// 表单ref
const ruleRef = ref(null);

// 弹窗参数
const dialogConfig = ref({
  tree: [],
});

// 品牌list
const brandList = ref([]);

// 信号list
const modelList = ref([]);

// 按钮防抖
const buttonLoading = ref(false);

// 树形选择的props
const defaultProps = reactive({
  label: "name",
  // disabled: (data) => {
  //   return data.parentId == "0";
  // },
});

// 表单
const formData = ref({
  name: "",
  nickname: "",
  number: "",
  categoryId: "",
  enable: "1",
  price: null,
});

// 表单校验
const rules = reactive({
  name: [{ required: true, message: "请输入药剂名称", trigger: "blur" }],
  number: [
    { required: true, message: "请输入药剂编号", trigger: "blur" },
    {
      pattern: /^[a-zA-Z0-9]+$/,
      message: "只能输入英文和数字",
      trigger: "blur",
    },
  ],
  categoryId: [{ required: true, message: "请选择药剂类别", trigger: "blur" }],
  price: [
    { required: true, message: "请输入药剂单价", trigger: "blur" },
    {
      pattern:
        /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
      message: "请输入正确金额格式,可保留两位小数",
      trigger: "blur",
    },
  ],
});

// 弹窗保存
const handleSUbmit = () => {
  buttonLoading.value = true;
  ruleRef.value?.validate((valid) => {
    if (valid) {
      if (dialogConfig.value.type) {
        addMedicament(formData.value);
      } else {
        editMedicament({
          ...formData.value,
          categoryId: formData.value.categoryId,
        });
      }
    } else {
      buttonLoading.value = false;
    }
  });
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 新增
const addMedicament = (req) => {
  insertMedicament(req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 编辑
const editMedicament = (req) => {
  updateMedicament(req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 通过id获取数据
const getDataById = (id) => {
  loading.value = true;
  queryMedicamentById(id)
    .then((res) => {
      const keys = ["id", "categoryId", "name", "nickname", "number", "price"];
      keys.forEach((key) => {
        formData.value[key] = res.data[key];
      });
    })
    .finally(() => {
      loading.value = false;
    });
};

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = { ...config };
  ruleRef.value?.resetFields();
  if (config.type) {
    formData.value = {
      name: "",
      nickname: "",
      number: "",
      categoryId: "",
      enable: "1",
      price: null,
    };
  } else {
    getDataById(config.row.id);
  }
  visible.value = true;
};

// 暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<style lang="scss" scoped></style>
